import Analytics from '../../assets/icons/trvto_analytics.svg';
import Billing from '../../assets/icons/trvto_billing.svg';
import Bookings from '../../assets/icons/trvto_bookings.svg';
import Dashboard from '../../assets/icons/trvto_dashboard.svg';
import Insights from '../../assets/icons/trvto_insights.svg';
import MyPackages from '../../assets/icons/trvto_my_packages.svg';
import Reviews from '../../assets/icons/trvto_reviews.svg';
import DasboardActive from '../../assets/icons/trvto_dashboardActive.svg';
import MyPackagesActive from '../../assets/icons/trvto_myPackagesActive.svg';
import AnalyticsActive from '../../assets/icons/trvto_analyticsActive.svg';
import ReviewActive from '../../assets/icons/trvto_ReviewActive.svg';
import BookingActive from '../../assets/icons/trvto_BookingActive.svg';
import InsightsActive from '../../assets/icons/trvto_insightsActive.svg';
import BillingActive from '../../assets/icons/trvto_billingActive.svg';

export const LeftMenuData = [
    {
        title: 'Dashboard',
        path: '/org/dashboard?type=next&datesType=fixed&page=1',
        icon: Dashboard,
        activeIcon: DasboardActive
    },
    {
        title: 'My Packages',
        path: '/org/my-pack?status=active&datesType=fixed&group=backpacking&page=1',
        icon: MyPackages,
        activeIcon: MyPackagesActive
    },
    {
        title: 'Billing/Payouts',
        path: '/org/billing?status=completed&approval=approved&page=1',
        icon: Billing,
        activeIcon: BillingActive
    },
    // {
    //     title: 'My Rooms',
    //     path: '/org/bookings',
    //     icon: MyRooms,
    //     activeIcon: MyRoomsActive
    // },
    {
        title: 'Bookings',
        path: '/org/bookings?type=upcoming&datesType=fixed&group=backpacking&page=1',
        icon: Bookings,
        activeIcon: BookingActive
    },
    {
        title: 'Review',
        path: '/org/reviews',
        icon: Reviews,
        activeIcon: ReviewActive
    },
    {
        title: 'Insights',
        path: '/org/insights',
        icon: Insights,
        activeIcon: InsightsActive
    },
    {
        title: 'Analytics',
        path: '/org/analytics',
        icon: Analytics,
        activeIcon: AnalyticsActive
    }
];

export const ActivityLeftMenuData = [
    {
        title: 'Dashboard',
        path: '/org/a/dashboard?type=next&&page=1',
        icon: Dashboard,
        activeIcon: DasboardActive
    },
    {
        title: 'My Activity',
        path: '/org/a/my-activity?status=active&page=1',
        icon: MyPackages,
        activeIcon: MyPackagesActive
    },
    {
        title: 'Billing/Payouts',
        path: '/org/a/billing?status=completed&approval=approved&page=1',
        icon: Billing,
        activeIcon: BillingActive
    },
    {
        title: 'Bookings',
        path: '/org/a/bookings?type=upcoming&page=1',
        icon: Bookings,
        activeIcon: BookingActive
    },
    {
        title: 'Review',
        path: '/org/a/reviews',
        icon: Reviews,
        activeIcon: ReviewActive
    },
    {
        title: 'Insights',
        path: '/org/a/insights',
        icon: Insights,
        activeIcon: InsightsActive
    },
    {
        title: 'Analytics',
        path: '/org/a/analytics',
        icon: Analytics,
        activeIcon: AnalyticsActive
    }
];

export const CampLeftMenuData = [
    {
        title: 'Dashboard',
        path: '/org/c/dashboard?date=next&&page=1',
        icon: Dashboard,
        activeIcon: DasboardActive
    },
    {
        title: 'My Camp',
        path: '/org/c/my-camps?status=active&page=1',
        icon: MyPackages,
        activeIcon: MyPackagesActive
    },
    {
        title: 'Billing/Payouts',
        path: '/org/c/billing?page=1',
        icon: Billing,
        activeIcon: BillingActive
    },
    {
        title: 'Bookings',
        path: '/org/c/bookings?date=upcoming&page=1',
        icon: Bookings,
        activeIcon: BookingActive
    },
    {
        title: 'Review',
        path: '/org/c/reviews',
        icon: Reviews,
        activeIcon: ReviewActive
    },
    {
        title: 'Insights',
        path: '/org/c/insights',
        icon: Insights,
        activeIcon: InsightsActive
    },
    {
        title: 'Analytics',
        path: '/org/c/analytics',
        icon: Analytics,
        activeIcon: AnalyticsActive
    }
];

export const GuidLeftMenuData = [
    {
        title: 'Dashboard',
        path: '/org/g/dashboard?type=next&&page=1',
        icon: Dashboard,
        activeIcon: DasboardActive
    },
    {
        title: 'My Guide',
        path: '/org/g/my-guide?status=active&page=1',
        icon: MyPackages,
        activeIcon: MyPackagesActive
    },
    {
        title: 'Billing/Payouts',
        path: '/org/g/billing?status=completed&approval=approved&page=1',
        icon: Billing,
        activeIcon: BillingActive
    },
    {
        title: 'Bookings',
        path: '/org/g/bookings?type=upcoming&page=1',
        icon: Bookings,
        activeIcon: BookingActive
    },
    {
        title: 'Review',
        path: '/org/g/reviews',
        icon: Reviews,
        activeIcon: ReviewActive
    },
    {
        title: 'Insights',
        path: '/org/g/insights',
        icon: Insights,
        activeIcon: InsightsActive
    },
    {
        title: 'Analytics',
        path: '/org/g/analytics',
        icon: Analytics,
        activeIcon: AnalyticsActive
    }
];
